// fetcher.js - FIXED VERSION
async function fetcher(url, token) {
  console.log('🔗 Fetching:', url); // Debug log
  
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(url, requestOptions);
    
    console.log('📡 Response:', response.status, response.statusText);
    
    // ✅ Handle 204 No Content - return empty but valid structure
    if (response.status === 204) {
      console.log('⚠️ 204 No Content - returning empty data');
      return { data: null, error: null, status: "ok" };
    }
    
    // ✅ Handle other error statuses
    if (!response.ok) {
      let errorMessage = `HTTP ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData?.message || errorData?.error || errorMessage;
      } catch (e) {
        // If error response isn't JSON, get text
        errorMessage = await response.text().catch(() => errorMessage);
      }
      console.error('❌ API Error:', errorMessage);
      return { data: null, error: errorMessage, status: "error" };
    }
    
    // ✅ Handle successful response with content
    const contentType = response.headers.get('content-type');
    
    // If no content-type or not JSON, return null data
    if (!contentType || !contentType.includes('application/json')) {
      console.log('⚠️ Non-JSON response');
      return { data: null, error: null, status: "ok" };
    }
    
    const res = await response.json();
    console.log('✅ Parsed response:', res);
    
    // ✅ Handle backend response format
    if (res?.status === "success") {
      return { data: res?.data, error: null, status: "ok" };
    }
    if (res?.status === "fail" || res?.status === "error") {
      return { data: null, error: res?.message || res?.error || 'Request failed', status: "error" };
    }
    
    // ✅ If backend doesn't use status field, assume success
    return { data: res, error: null, status: "ok" };
    
  } catch (error) {
    console.error('❌ Network Error:', error);
    return { 
      data: null, 
      error: error.message || 'Network error', 
      status: "error" 
    };
  }
}

export default fetcher;